<template>
  <div>
    <collapse :active-index="0">
      <collapse-item>
        <h3 slot="title" class="mb-0">Información del Establecimiento</h3>

        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div>
              <p class="h5 mb-0">Nombre</p>
              <p>{{ field.name }}</p>
            </div>
            <div>
              <p class="h5 mb-0">Dirección</p>
              <p>{{ field.address }}</p>
            </div>
            <div>
              <p class="h5 mb-0">Localidad</p>
              <p>{{ field.city.name }}, {{ field.city.province.name }}</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-sm-12">
            <div>
              <p class="h5 mb-0">Productor</p>
              <p v-if="$can('show', 'producers')">
                <router-link :to="{ name: 'ProducerShow', params: { id: field.producer.id } }" class="like btn-link">
                  {{ field.producer.businessName }}
                </router-link>
              </p>
              <p v-else>{{ field.producer.businessName }}</p>
            </div>

            <div>
              <p class="h5 mb-0">Coordenadas</p>
              <a target="_blank" :href="mapLink"> {{ field.latitude }}°, {{ field.longitude }}° </a>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <div>
                  <p class="h5 mb-0">Hectáreas</p>
                  <p>{{ field.hectares }}</p>
                </div>
              </div>
            </div>

            <div>
              <badge class="mb-0" type="danger">
                <span class="mr-1">{{ field.plotsCount }}</span>
                <span v-if="field.plotsCount === 1">Lote</span>
                <span v-else>Lotes</span>
              </badge>
            </div>
          </div>

          <div v-if="staticUrl" class="col-lg-5 col-md-6 col-sm-12">
            <img :src="staticUrl" alt="" />
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'FieldData',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    field: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      staticUrl: null,
    };
  },

  computed: {
    mapLink() {
      const params = `/@${this.field.latitude},${this.field.longitude},10z`;
      return this.$services.resource('maps').staticPlace(this.field.latitude, this.field.longitude) + params;
    },
  },

  created() {
    this.staticUrl = this.$services.resource('maps').staticMap({
      lat: this.field.latitude,
      lng: this.field.longitude,
      zoom: 7,
    });
  },
};
</script>
